import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "name", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    for: _ctx.variavel.getId()
  }, [
    _createTextVNode(_toDisplayString(_ctx.variavel.getLabel()) + " ", 1),
    _createElementVNode("input", {
      type: "text",
      id: _ctx.variavel.getId(),
      name: _ctx.variavel.getId(),
      value: _ctx.valor,
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateValor && _ctx.updateValor(...args))),
      autocomplete: "off"
    }, null, 40, _hoisted_2)
  ], 8, _hoisted_1))
}